"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AliffBoundaryUserDataSchema = exports.AliffExportTimeErrorCode = exports.AliffShapeType = exports.AliffRuleType = void 0;
const zod_1 = require("zod");
//
// ALIFF Design Rule types
//
var AliffRuleType;
(function (AliffRuleType) {
    AliffRuleType["clearance"] = "clearance";
    AliffRuleType["allowViaAtSmd"] = "allowViaAtSmd";
    AliffRuleType["rotateFirst"] = "rotateFirst";
    AliffRuleType["pinConnectionPoint"] = "pinConnectionPoint";
    AliffRuleType["routingDirection"] = "routingDirection";
})(AliffRuleType || (exports.AliffRuleType = AliffRuleType = {}));
//
// ALIFF shape types
//
var AliffShapeType;
(function (AliffShapeType) {
    AliffShapeType["circle"] = "circle";
    AliffShapeType["rectangle"] = "rectangle";
    AliffShapeType["polyline"] = "polyline";
    AliffShapeType["path"] = "path";
    AliffShapeType["polygon"] = "polygon";
    AliffShapeType["polygonWithHoles"] = "polygonWithHoles";
})(AliffShapeType || (exports.AliffShapeType = AliffShapeType = {}));
var AliffExportTimeErrorCode;
(function (AliffExportTimeErrorCode) {
    AliffExportTimeErrorCode["DIFFERENTIAL_PAIRS_PINS_MISMATCH"] = "DIFFERENTIAL_PAIRS_PINS_MISMATCH";
    AliffExportTimeErrorCode["UNSUPPORTED_VIA_CONFIG"] = "UNSUPPORTED_VIA_CONFIG";
    AliffExportTimeErrorCode["POWER_LAYER_AVOIDED"] = "POWER_LAYER_AVOIDED";
    AliffExportTimeErrorCode["POLYGON_PROTECTED"] = "POLYGON_PROTECTED";
})(AliffExportTimeErrorCode || (exports.AliffExportTimeErrorCode = AliffExportTimeErrorCode = {}));
exports.AliffBoundaryUserDataSchema = zod_1.z.object({
    layoutUid: zod_1.z.string().optional(),
    objectIdToNodeUidMap: zod_1.z.record(zod_1.z.string(), zod_1.z.string()),
});
//# sourceMappingURL=aliff.js.map